<py-drawer-header [showBackButton]="showBackButton" (backButtonClick)="onBackButtonClick()" [title]="title">
  <ng-container [ngTemplateOutlet]="activeHeader"></ng-container>
</py-drawer-header>

<ng-container [ngTemplateOutlet]="activeBody"></ng-container>

<py-drawer-footer *ngIf="activeFooter" [template]="activeFooter"></py-drawer-footer>
